export const shareRecordValidations = (
  isSetExpirationLimit: boolean,
  formattedDate: Date | null,
  startTime: any,
  isShareWith: boolean,
  selectedEmployee: any[],
  emailAddressList: string[],
  selectedCaseRecordDetailsIds: string[],
  caseID: number | undefined
): string[] => {
  const errors: string[] = [];

  if (!caseID) {
    errors.push("Please select Case ID");
  }
  if (selectedCaseRecordDetailsIds?.length === 0) {
    errors.push("Please select at least one Record File");
  }
  if (isShareWith && (selectedEmployee?.length === 0)) {
    errors.push("Please select User");
  }
  if (!isShareWith && (emailAddressList?.length === 0)) {
    errors.push("Please add user Email");
  }
  console.log(emailAddressList,'emailAddressList');
  
  if(!isShareWith && emailAddressList?.length > 0) {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      const emailSet = new Set();
      emailAddressList.forEach((email) => {
        const trimmedEmailAddress = email.toString().trim();

        if (!emailRegex.test(trimmedEmailAddress)) {
          errors.push(`Invalid Email Address: ${trimmedEmailAddress}`);
        }

        if (emailSet.has(trimmedEmailAddress)) {
          errors.push(`Duplicate Email Address: ${trimmedEmailAddress}`);
        } else {
          emailSet.add(trimmedEmailAddress);
        }
      });
  }
  if (isSetExpirationLimit && !formattedDate) {
    errors.push("Please select expiration date");
  }
  if (isSetExpirationLimit && !startTime) {
    errors.push("Please select time");
  }

  return errors;
};
